import { DocumentCreationInfo } from './creation-info.interface';

interface SendEmailRequest {
    // Required fields
    toEmail: string;
    messageContent: string;
    language: string;

    // Optional fields
    messageTitle?: string;
    clientApiKeyId?: string;
    notificationTemplateId?: string;
    scheduledDate?: Date | string;
}

export interface NotificationRequest {
    phoneNumber: string;
    messageContent: string;
    url: string;
    clientApiKeyId: number;
    notificationTemplateId: number;
    scheduledDate: string | null;
    language: string;
}

export interface Notification {
    id: number;
    clientId: number;
    notificationType: MessageType;  // Changed to enum type
    recipient: string;
    messageContent: string;
    subject: string;
    url: string | null;            // Made nullable
    clientApiKeyId: number | null; // Made nullable
    notificationTemplateId: number | null; // Made nullable
    sentAt: string;                // New field
    status: MessageStatus;         // New field with enum type
    createdBy?: number | string | null;
    creationInfo?: DocumentCreationInfo | null;
    language: string;
}

export enum MessageStatus {
    Pending = 'Pending',
    Sent = 'Sent',
    Failed = 'Failed',
    Delivered = 'Delivered',
    Read = 'Read'
}

export const MessageStatusTranslations: Record<MessageStatus, string> = {
    [MessageStatus.Pending]: 'قيد الانتظار',
    [MessageStatus.Sent]: 'تم الإرسال',
    [MessageStatus.Failed]: 'فشل',
    [MessageStatus.Delivered]: 'تم التوصيل',
    [MessageStatus.Read]: 'تم القراءة'
};

export enum MessageType {
    SMS = 'SMS',
    WhatsApp = 'WhatsApp',
    Email = 'Email',
}

export const MessageTypeTranslations: Record<MessageType, string> = {
    [MessageType.SMS]: 'رسالة نصية',
    [MessageType.WhatsApp]: 'واتساب',
    [MessageType.Email]: 'بريد إلكتروني',
};

export function mapNotificationToRequest(notification: Notification): NotificationRequest {
    return {
        phoneNumber: notification.recipient,
        messageContent: notification.messageContent,
        url: notification.url || '',
        clientApiKeyId: notification.clientApiKeyId || 0,  // Handle null -> 0
        notificationTemplateId: notification.notificationTemplateId || 0,  // Handle null -> 0
        scheduledDate: null,  // Not available in Notification
        language: notification.language
    };
}